<template lang="pug">
v-container
  v-stepper(v-if="contract" v-model="step" vertical elevation="0" )
    template(v-for="(step, idx) in steps" )
      v-stepper-step(
        :step="+idx + 1" :key="`${step.key}-step`"
        :editable="step.editable"
        color="secondary"
      ) {{ step.name }}

      v-stepper-content(:step="+idx + 1" :key="`${step.key}-content`")
        component(:is="step.component", v-bind="step.attrs" v-on="step.listeners")
        v-row.ma-1
          v-btn(
            v-if="step.declineBtn && !noStep"
            color="error"
            @click="step.declineBtn.method"
          ) Назад
          v-spacer
          v-btn(
            v-if="step.confirmBtn"
            color="primary"
            :disabled="step.confirmBtn.disabled"
            @click="step.confirmBtn.method"
          ) {{ step.confirmBtn.name }}
  v-sheet(height="300" v-else).d-flex.align-center
    v-progress-circular(
      size="80"
      color="primary"
    )
  template(v-if="!steps.length")
    v-alert.ma-2(type="info" text).
      Организация, осуществляющая обучение, не предусмотрела форму договора. К сожалению,
      пока она этого не сделает подать заявку на платный курс не удастся. Если есть возможность,
      пожалуйста, доведите до организации эту информацию...
</template>
<script>
import BankDetails from '@/modules/PaymentSystem/components/BankDetails.vue';
import ConfirmConclusionContract from './ConfirmConclusionContract.vue';
import ReadySendContract from './ReadySendContract.vue';
// import ChooseContract from './ChooseContract.vue';
import ContractDetails from './ContractDetails.vue';

export default {
  props: {
    employees: { type: Array, default: () => [] },
    enrollmentId: { type: Number, default: null },
    price: { type: [Number, String], default: 0 },
    noStep: { type: Boolean, default: false },
    params: { type: Object, default: null },
    successCallback: { type: Function, required: true },
    organizationId: { type: Number, default: null },
    initContract: { type: Object, default: null },
  },
  data() {
    return {
      employContract: {},
      customerData: null,
      step: 1,
      contracts: [],
      contract: this.initContract?.typical_contract || null,
      confirmBox: false,
      loading: false,
      agreement: null,
    };
  },
  computed: {

    steps() {
      const ReadySend = {
        key: 1,
        name: 'Подтвердите готовность отправки заявки на обучение перечисленных сотрудников',
        editable: true,
        component: ReadySendContract,
        attrs: {
          agreementId: this.agreement?.id,
          employees: this.employees,
          successCallback: () => { this.step = 2; },
        },
      };
      // const Choose = {
      //   key: 2,
      //   name: 'Выбор договора',
      //   editable: this.contract !== null,
      //   component: ChooseContract,
      //   attrs: {
      //     price: this.price,
      //     employeesLength: this.employees.length,
      //     contracts: this.contracts,
      //   },
      //   listeners: {
      //     choose: (val) => { this.chooseContract(val); },
      //   },
      // };
      const CheckDetails = {
        key: 2,
        name: 'Проверка реквизитов',
        editable: false,
        component: BankDetails,
        attrs: {
          cols: true,
          successCallback: () => { this.step = 3; },
          backBtnEvent: () => { this.step = 1; },
        },
      };
      const Details = {
        key: 3,
        name: 'Договор',
        editable: false,
        component: ContractDetails,
        attrs: {
          cols: true,
          noStep: this.noStep,
          nextBtnName: this.initContract ? 'Сохранить изменения в текст договора' : 'Продолжить',
          loading: this.loadingChoose,
          successCallback: (data, callback) => {
            this.customerData = data;
            this.saveContract(callback);
          },
          backBtnEvent: () => { this.step = 2; },
        },
      };
      const Confirm = {
        key: 4,
        name: 'Подтверждение создания договора',
        editable: false,
        component: ConfirmConclusionContract,
        attrs: {
          agreementId: this.agreement?.id,
          noStep: this.noStep,
          contract: this.contract,
          readyContract: this.employContract,
        },
        listeners: {
          change: (val) => { this.confirmBox = val; },
        },
        declineBtn: this.noStep ? null : {
          method: () => { this.step = 2; },
        },
        confirmBtn: {
          name: 'Подать заявку на заключение договора',
          disabled: !this.confirmBox,
          method: () => { this.save(); },
        },
      };
      // const needToCheckDetails = this.contract?.is_offer;
      if (this.noStep) {
        return [
          Details,
          ...this.initContract ? [] : [Confirm],
        ];
      }
      return [
        ReadySend,
        // Choose,
        CheckDetails,
        Details,
        ...this.initContract ? [] : [Confirm],
      ];
    },
  },
  created() {
    if (!this.initContract) this.fetchContracts();
    this.getAgreement();
  },
  methods: {
    async getAgreement() {
      const { data } = await this.$api.contracts.getAgreements({
        'search[organization_id]': this.organizationId,
        'search[is_main_policy]': true,
      });
      [this.agreement] = data.data;
    },
    async fetchContracts() {
      const params = {
        params: this.params,
      };
      this.loading = true;
      const { data } = await this.$api.contracts.getTypicalContract(params);
      const items = data.data;

      this.contract = items
        .find((i) => i.type === (this.noStep ? 1 : this.$conf.CONTRACT_TYPES.ur) && i.is_offer);

      this.loading = false;
    },

    saveContract(callback) {
      this.loadingChoose = true;
      // this.contract = val;
      const users = this.noStep ? [{
        id: this.$user.data.id,
        address: this.customerData.address,
        phone: this.customerData.customer_contact_phone,
        full_name: this.customerData.customer_contact_full_name,
      }] : this.employees
        .map(({
          id, full_name: fullName, address, phone,
        }) => ({
          id, full_name: fullName, address, phone,
        }));
      const payload = {
        typical_contract_id: this.contract.id,
        prior_record_id: this.$route.params.enrollmentId || this.enrollmentId,
        ...this.initContract ? {
          id: this.initContract.id,
          prior_record_id: this.initContract.prior_record_id,
          typical_contract_id: this.initContract.typical_contract_id,
        } : {},
        users,
        ...this.customerData,
      };
      const method = this.initContract ? 'updateContracts' : 'createContracts';
      this.$rHandler(
        this.$api.contracts[method](payload, { params: { expand: 'document,preview_document' } }),
        ({ data }) => {
          this.employContract = data.data;
          this.step = this.noStep ? 2 : 4;
          this.loadingChoose = false;
          callback();
          if (this.initContract) this.successCallback(this.employContract.id);
        },
        (e) => console.error(e),
      );
    },
    save() {
      const payload = {
        id: this.employContract.id,
        is_active: true,
      };
      this.$rHandler(
        this.$api.contracts.updateContracts(payload),
        () => {
          this.successCallback(this.employContract.id);
        },
      );
    },
  },
};
</script>
